import { getChatApiRoute } from '@renderer/chat/api/v1Client'
import type { Skill } from '@renderer/chat/types'
import { fetchWithAuth } from './skills-api'

export interface OrganizationSkill extends Skill {
  subscribed: boolean
  subscriberCount: number
}

export interface OrganizationSkillSubscriptionInput {
  organizationId: string
  skillId: string
  subscribed: boolean
}

interface OrganizationSkillsResponse {
  data?: Array<OrganizationSkill>
}

export async function fetchOrganizationSkills(
  organizationId: string,
  token: string,
): Promise<Array<OrganizationSkill>> {
  const json = (await fetchWithAuth(
    getChatApiRoute(`api/v1/organizations/${organizationId}/skills`),
    token,
  )) as OrganizationSkillsResponse
  return json.data ?? []
}

export async function setOrganizationSkillSubscription(
  input: OrganizationSkillSubscriptionInput,
  token: string,
): Promise<void> {
  await fetchWithAuth(
    getChatApiRoute(`api/v1/organizations/${input.organizationId}/skills/${input.skillId}/subscription`),
    token,
    { method: input.subscribed ? 'PUT' : 'DELETE' },
  )
}
